import Dialog from "dialog";
import template from "../html/dialog-open.html";
import css from "../css/dialog-open.css";

class OpenDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-opendialog", OpenDialog);
	}
	constructor() {
		super();
		
		this.show();
	}
	buttonSave_click(event) {
	}
	buttonClose_click(event) {
		this.close();
	}
}

OpenDialog.constructor();

export default OpenDialog;